<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Y0IWMq/tc-custom/9781429987202.jpg?1731209090954" alt="This image is the cover for the book Rage of the Dragon, The Dragonships of Vindras Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rage of the Dragon, The Dragonships of Vindras Novels
      </h1>
      <p class="bookDescription body article font2">
        <p>From <i>New York Times</i> bestselling authors Margaret Weis and Tracy Hickman comes <i>Rage of the Dragon</i>, the action-packed third book in their Dragonships fantasy series.<br/><br/>Skylan Ivorson is the gods-chosen Chief of all Vindras clans. But the gods from whom the Vindrasi draw their earthdwelling power are besieged by a new generation of gods who are challenging them for the powers of creation. The only way to stop these brash interlopers lies within the Five Bones of the Vektia Dragon—the primal dragon forged during the creation of the world—which have been lost for generations.<br/><br/>With the Gods of the New Dawn amassing a vast army, Skylan finds allies in former enemies. Calling upon the ogres to fight their common foes, the Vindrasi soon find themselves in the middle of an even larger war. Skylan and his Vindrasi clan must sail the Sea of Tears into the heart of the Forbidden Empire of the Cyclops, to implement a cunning yet delicate plan that risks his life and leadership at every corner. But a new enemy lies deep in the sea, one who draws upon powers never harnessed by land dwellers.<br/><br/>Master world-builders Margaret Weis and Tracy Hickman, who have entertained generations of fans with the Dragonlance series and the Death Gate Cycle, prove they're at the top of their game.<br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margaret Weis, Tracy Hickman
      </h2>
      
      <p class="authorDescription body article"><P>MARGARET WEIS and TRACY HICKMAN published their first novel in the Dragonlance™ Chronicles, <I>Dragons of Autumn Twilight</I>, in 1984. Together, the pair worked on over a dozen other titles in the series, and they are still going strong, collaborating on more than thirty novels. Margaret Weis lives in Williams Bay, Wisconsin. Tracy Hickman lives in Utah.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5597cd2c